import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getStaticImageUrl } from 'client/utils/image-helpers';

import './youtube-preview-logo.scss';

export function YoutubePreviewLogo({ className = 'mb-0_5 me-0_5' }) {
  return (
    <div className={classnames('youtube-preview-logo d-flex pos-a bottom-0 right-0', className)}>
      <img width="100%" src={getStaticImageUrl('/img/logos/youtube-white.png')} alt="Youtube" loading="lazy" />
    </div>
  );
}

YoutubePreviewLogo.propTypes = {
  className: PropTypes.string,
};
